import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=06590ffd&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=ts"
export * from "./ForgottenPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06590ffd",
  null
  
)

export default component.exports